<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100" style="
                  background-image: url('/img/73605794_2308_back.webp');
                  background-size: cover;
                ">
        <div class="container" >
          <div class="row">
            <div class="col-12" style="margin-top: 5dvh;">
              <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
                <div class="card card-plain">
                  <div class="pb-0 card-header text-start">
                    <h4 class="font-weight-bolder">¡Bienvenido!</h4>
                    <p>Ingresa tu usuario y contraseña</p>
                  </div>
                  <div class="card-body bg-white">
                    <form role="form" @submit.prevent="handleLogin()">
                      <div class="mb-3">
                        <argon-input
                          v-model="user.username"
                          type="text"
                          class="mb-0"
                          placeholder="Nombre de Usuario"
                          name="username"
                          size="lg"
                          :value="user.username"
                        />
                        <validation-error
                          :errors="apiValidationErrors.username"
                        />
                      </div>
                      <div class="mb-3">
                        <Password v-model="user.password" placeholder="Contraseña" :feedback="false" toggleMask class="w-100" id="passwordLogin"/>
                      </div>
                      <div class="text-center">
                        <argon-button
                          class="mt-4"
                          variant="gradient"
                          color="addiuva"
                          fullWidth
                          size="lg"
                          >Ingresar</argon-button
                        >
                      </div>
                    </form>
                  </div>
                  <div class="card-footer bg-white"></div>
                </div>
              </div>
            </div>
            <!--  -->
            <div class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="align-items:center;"
              >
                <img
                  :src="logo"
                  style="width:200px;"
                  alt="main_logo"
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Password from 'primevue/password';
import formMixin from "../../mixins/form-mixin.js";
import ValidationError from "../../components/ValidationError.vue";
import showSwal from "../../mixins/showSwal.js";
import logo from "@/assets/img/Logo-ADDIUVA_White.png";
const body = document.getElementsByTagName("body")[0];

export default {
  name: "Login",
  components: {
    // Navbar,
    ArgonInput,
    Password,
    ArgonButton,
    ValidationError,
  },
  mixins: [formMixin, showSwal],
  data() {
    return {
      user: {
        username: "",
        password: "",
      },
      logo
    };
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods: {
    async handleLogin() {
      try {
        await this.$store.dispatch("auth/login", this.user);
        if (localStorage.getItem('access_token')) {
          location.reload(true);
        }
      } catch (error) {
        this.showSwal({
          type: "error",
          message: "Crendeciales Invalidas",
        });
      }
    },
  }
};
</script>
<style lang="css" scoped>
  .page-header::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(30 16 65 / 75%);
    z-index: 1;
  }
</style>